module.exports = __webpack_public_path__ + "media/images/mobile/home/back_btn-aa2271b7ce9b7f1d20c130a31726f5c1.png";